module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN400_1276573761.e9796dc6.png";